import React, { useEffect, useState } from "react";
import { Navbar } from "../components/site/Navbar";
import { Hero } from "../components/site/Hero";
import { WhoIsJT } from "../components/site/WhoIsJT";
import { Resume } from "../components/site/Resume";
import { Journey } from "../components/site/Journey";
import { Highlights } from "../components/site/Highlights";
import { Schedule } from "../components/site/Schedule";
import { Shop } from "../components/site/Shop";
import { Partnerships } from "../components/site/Partnerships";
import { FinalSection } from "../components/site/FinalSection";
import { TrackingTags } from "../components/site/TrackingTags";
import { CartDrawer } from "../components/site/CartDrawer";
import api from "../lib/api";

export default function Home() {
  const [settings, setSettings] = useState(null);

  useEffect(() => {
    api.get("/settings").then((res) => setSettings(res.data)).catch(() => {});
  }, []);

  return (
    <div className="grain bg-matte text-cream overflow-x-hidden">
      <TrackingTags settings={settings} />
      <Navbar />
      <Hero />
      <WhoIsJT />
      <Resume />
      <Journey />
      <Highlights />
      <Schedule settings={settings} />
      <Shop settings={settings} />
      <Partnerships settings={settings} />
      <FinalSection settings={settings} />
      <CartDrawer />
    </div>
  );
}
